import { render, staticRenderFns } from "./AdminNews.vue?vue&type=template&id=8ea5f542&scoped=true"
import script from "./AdminNews.vue?vue&type=script&lang=js"
export * from "./AdminNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea5f542",
  null
  
)

export default component.exports